import { render } from "./AssignUserPage.vue?vue&type=template&id=4e6ab00e"
import script from "./AssignUserPage.vue?vue&type=script&lang=js"
export * from "./AssignUserPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__